import React, { createContext, useContext } from 'react';

export const SnackbarContext = createContext({
    showSuccessSnackbar: (text) => {},
    showErrorSnackbar: (text) => {},
    showSnackbar: (text) => {},
    showPurchaseSuccessSnackbar: (coinsAmount) => {},
});

export const useSnackbar = () => useContext(SnackbarContext);
